var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 20C5.25 17.5 7.25 15.6 9.65 15.6H14.75C17.25 15.6 19.15 17.6 19.15 20",
    fill: "#0450DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 20C5.25 17.5 7.25 15.6 9.65 15.6H14.75C17.25 15.6 19.15 17.6 19.15 20H5.25Z",
    stroke: "#0450DD",
    strokeWidth: 1.4824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 5.2C16.95 6.9 16.95 9.6 15.25 11.2C13.55 12.8 10.85 12.9 9.24999 11.2C7.64999 9.5 7.54999 6.8 9.24999 5.2C10.95 3.6 13.55 3.6 15.25 5.2Z",
    fill: "#0450DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 5.2C16.95 6.9 16.95 9.6 15.25 11.2C13.55 12.8 10.85 12.9 9.24999 11.2C7.64999 9.5 7.54999 6.8 9.24999 5.2C10.95 3.6 13.55 3.6 15.25 5.2",
    stroke: "#0450DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActive);
export default __webpack_public_path__ + "static/media/account_active.e63e1e20b9c821a189a042f43a903065.svg";
export { ForwardRef as ReactComponent };